/* Customize My Bed: UI, 2D bed preview and add-to-cart. Data model lives in bed-builder-core.js. */
(function () {
  var Core = window.BedBuilderCore;

  var COLORS = {
    'white': '#fbfaf7', 'antique white': '#f6f0e4', 'creme': '#f3ead8', 'crème': '#f3ead8', 'cream': '#f3ead8', 'ecru': '#efe6d2',
    'natural': '#e6dccb', 'champagne': '#e9d7bd', 'as shown': '#efe9e2', 'haze': '#d6d3cc',
    'rose': '#e3bbb6', 'soft rose': '#e6bcb8', 'petal': '#f1d1cf', 'petal pink': '#f1d1cf', 'ballet pink': '#f2c9c9',
    'pink': '#efb9c0', 'pink sorbet': '#f4b6bd', 'blush': '#f0cfc8', 'fiesta': '#e98a8f',
    'lilac': '#cdbfe0', 'sweet lilac': '#d8c8e6', 'pastel': '#eadbe6', 'soft pastels': '#eadbe6',
    'chambray': '#9fb3c8', 'french blue': '#6f8fb5', 'soft blue': '#bcd0e3', 'sky blue': '#b9cfe4', 'teacup blue': '#a9c6de',
    'true blue': '#4c6fa8', 'denim': '#5d7695', 'indigo': '#3f4e7a', 'turquoise': '#6fb7b5', 'dark teal': '#2f5d62',
    'sage': '#b7c4a8', 'soft sage': '#c3cdb5', 'aloe': '#a8b89a', 'topaz': '#c9a46a', 'maple': '#b97a4b',
    'cacao': '#6b4a3a', 'aubergine': '#5a3a4f', 'soft grey': '#c9c9c7', 'grey': '#b3b3b1', 'medium grey': '#9a9a98', 'wheat': '#e2cfa6',
    'olive': '#8b8a5e', 'mist': '#d8dcd9', 'cherry': '#9b2c3c', 'coal': '#3d3b3a', 'sea glass': '#a9cdc4', 'teal': '#3f7f80', 'soft nude': '#e8cfc0', 'rose blush': '#e7bfbb'
  };

  function hexFor(name) {
    var key = String(name || '').toLowerCase().trim();
    if (COLORS[key]) return COLORS[key];
    var words = key.split(' ');
    for (var i = words.length - 1; i >= 0; i--) if (COLORS[words[i]]) return COLORS[words[i]];
    return '#efe9e2';
  }

  function knownColor(name) {
    var key = String(name || '').toLowerCase().trim();
    return !!COLORS[key] && key !== 'as shown' || key.split(' ').some(function (w) { return COLORS[w] && w !== 'as'; }) && key.indexOf(',') < 0;
  }

  // How far apart two color names look (0 = same). Used to suggest coordinating pieces.
  function colorDistance(a, b) {
    if (String(a).toLowerCase() === String(b).toLowerCase()) return -1;
    if (!knownColor(a)) return 999;
    var x = hexFor(a).match(/\w\w/g).map(function (h) { return parseInt(h, 16); });
    var y = hexFor(b).match(/\w\w/g).map(function (h) { return parseInt(h, 16); });
    return Math.sqrt(Math.pow(x[0] - y[0], 2) * 0.3 + Math.pow(x[1] - y[1], 2) * 0.59 + Math.pow(x[2] - y[2], 2) * 0.11);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function cropUrl(url, w) {
    if (!url) return '';
    var u = url.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'height=' + w + '&crop=center';
  }

  var PIECE_NAMES = { duvet: 'Duvet cover', sham: 'Shams', pillowcase: 'Pillowcases', sheetset: 'Sheet set', bedskirt: 'Bedskirt', pillow: 'Decorative pillow', throw: 'Throw' };
  var SIZE_NAMES = { twin: 'Twin', full: 'Full', queen: 'Queen', king: 'King' };

  function BedBuilder(el) {
    this.el = el;
    var raw = JSON.parse(document.getElementById('BedBuilderData-' + el.getAttribute('data-section-id')).textContent);
    this.moneyFormat = raw.moneyFormat;
    var seen = {};
    var products = raw.products.filter(function (p) { if (seen[p.id]) return false; seen[p.id] = true; return true; });
    this.model = Core.buildModel(products);
    this.model.styles.sort(function (a, b) { return b.colors.length - a.colors.length; });
    var seenExtra = {};
    this.extras = raw.extras.filter(function (x) { if (seenExtra[x.id]) return false; seenExtra[x.id] = true; x.variants = x.variants.filter(Boolean); return x.variants.length; });
    this.state = { style: null, size: null, color: null, lines: {} };
    this.q = function (sel) { return el.querySelector(sel); };
    this.renderBed();
    this.renderStyles();
    this.bind();
    this.applyParams();
  }

  BedBuilder.prototype.money = function (cents) {
    var amount = (cents / 100).toFixed(2);
    var noDec = Math.round(cents / 100).toString();
    var withComma = function (n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return this.moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma(noDec))
      .replace(/\{\{\s*amount\s*\}\}/, withComma(amount.split('.')[0]) + '.' + amount.split('.')[1])
      .replace(/<[^>]+>/g, '');
  };

  /* ---------- 2D bed ---------- */

  BedBuilder.prototype.renderBed = function () {
    if (!this.q('[data-bb-canvas]') || !window.BedArt) return; // simple builder: no drawing
    this.q('[data-bb-canvas]').innerHTML = window.BedArt.svg();
    this.painted = {};
  };

  // choice = { color, src } where src is the product name/style text that decides the trim (ruffle, tatter, crochet...)
  BedBuilder.prototype.paint = function (kind, choice, count) {
    if (!this.q('[data-bb-canvas]')) return;
    var layer = this.q('[data-bb-canvas] [data-bb-layer="' + kind + '"]');
    if (!layer) return;
    layer.classList.toggle('is-on', !!choice);
    if (!choice) return;
    var key = choice.color + '|' + choice.src + '|' + (count || 1);
    if (this.painted[kind] === key) return;
    this.painted[kind] = key;
    var o = window.BedArt.styleOf(choice.src);
    o.hex = hexFor(choice.color);
    layer.innerHTML = window.BedArt.layer(kind, o, count);
  };

  // Before pieces are chosen, dress the bed in the style's own duvet, shams and pillowcases
  BedBuilder.prototype.previewStyle = function () {
    var st = this.state, s = st.style;
    if (!s || Object.keys(st.lines).length) return;
    var c = st.color || s.colors[0], self = this;
    var src = s.name + ' ' + (s.detail || '') + ' ' + (s.sample || '');
    var n = st.size === 'twin' ? 1 : 2;
    var has = function (k) { return c.pieces.some(function (p) { return p.piece === k; }); };
    ['duvet', 'sham', 'pillowcase', 'sheetset', 'bedskirt', 'pillow', 'throw'].forEach(function (k) {
      var on = k === 'duvet' || ((k === 'sham' || k === 'pillowcase') && has(k));
      self.paint(k, on ? { color: c.name, src: src } : null, n);
    });
  };

  BedBuilder.prototype.setSize = function (bed) {
    if (window.BedArt && this.q('[data-bb-canvas] svg')) window.BedArt.setSize(this.q('[data-bb-canvas] svg'), bed);
  };

  /* ---------- steps ---------- */

  BedBuilder.prototype.renderStyles = function () {
    var self = this;
    this.q('[data-bb-styles]').innerHTML = this.model.styles.map(function (s, i) {
      var min = Infinity;
      s.colors.forEach(function (c) { c.pieces.forEach(function (p) { if (p.piece === 'duvet' && p.available) min = Math.min(min, p.price); }); });
      return '<button type="button" class="BedBuilder__StyleCard" data-bb-style="' + i + '">' +
        '<span class="BedBuilder__StyleImg" style="background-image:url(' + esc(cropUrl(s.image, 300)) + ')"></span>' +
        '<span class="BedBuilder__StyleName">' + esc(s.name) + '</span>' +
        (s.detail ? '<span class="BedBuilder__StyleDetail">' + esc(s.detail) + '</span>' : '') +
        '<span class="BedBuilder__StyleMeta">' + s.colors.length + (s.colors.length === 1 ? ' color' : ' colors') + ' · duvet from ' + self.money(min) + '</span>' +
      '</button>';
    }).join('');
  };

  BedBuilder.prototype.unlock = function (step) {
    var li = this.q('[data-bb-step="' + step + '"]');
    li.classList.remove('is-locked');
    return li;
  };

  BedBuilder.prototype.selectStyle = function (i) {
    var s = this.model.styles[i];
    this.state.style = s;
    this.state.color = null;
    this.state.lines = {};
    [].forEach.call(this.el.querySelectorAll('[data-bb-style]'), function (b) { b.classList.toggle('is-selected', +b.getAttribute('data-bb-style') === i); });
    var sizes = Core.BED_SIZES.map(function (bed) {
      var ok = s.colors.some(function (c) { var d = Core.pieceFor(c.pieces, 'duvet', bed); return d && d.available; });
      return '<button type="button" class="BedBuilder__Pill" data-bb-size="' + bed + '"' + (ok ? '' : ' disabled') + '>' + SIZE_NAMES[bed] + '</button>';
    }).join('');
    this.q('[data-bb-sizes]').innerHTML = sizes;
    this.unlock('size');
    if (this.state.size && this.q('[data-bb-size="' + this.state.size + '"]:not([disabled])')) this.selectSize(this.state.size);
    else { this.state.size = null; this.lockFrom('color'); }
    this.previewStyle();
    this.caption();
    this.scrollTo('size');
  };

  BedBuilder.prototype.selectSize = function (bed) {
    var s = this.state.style;
    this.state.size = bed;
    this.setSize(bed);
    [].forEach.call(this.el.querySelectorAll('[data-bb-size]'), function (b) { b.classList.toggle('is-selected', b.getAttribute('data-bb-size') === bed); });
    this.q('[data-bb-colors]').innerHTML = s.colors.map(function (c, i) {
      var d = Core.pieceFor(c.pieces, 'duvet', bed);
      var ok = d && d.available;
      return '<button type="button" class="BedBuilder__Swatch" data-bb-color="' + i + '"' + (ok ? '' : ' disabled') + ' title="' + esc(c.name) + (ok ? '' : ' (sold out in this size)') + '">' +
        '<span class="BedBuilder__SwatchDot" style="background-color:' + hexFor(c.name) + ';background-image:url(' + esc(cropUrl(c.image, 120)) + ')"></span>' +
        '<span class="BedBuilder__SwatchName">' + esc(c.name) + '</span></button>';
    }).join('');
    this.unlock('color');
    var keep = this.state.color && s.colors.indexOf(this.state.color);
    var firstOk = -1;
    s.colors.forEach(function (c, i) { var d = Core.pieceFor(c.pieces, 'duvet', bed); if (firstOk < 0 && d && d.available) firstOk = i; });
    if (s.colors.length === 1 && firstOk === 0) this.selectColor(0);
    else if (keep > -1 && this.q('[data-bb-color="' + keep + '"]:not([disabled])')) this.selectColor(keep);
    else this.lockFrom('pieces');
    this.previewStyle();
    this.caption();
    if (s.colors.length > 1) this.scrollTo('color');
  };

  BedBuilder.prototype.selectColor = function (i) {
    var c = this.state.style.colors[i];
    this.state.color = c;
    [].forEach.call(this.el.querySelectorAll('[data-bb-color]'), function (b) { b.classList.toggle('is-selected', +b.getAttribute('data-bb-color') === i); });
    this.buildLines();
    this.renderPieces();
    this.unlock('pieces');
    this.update();
    this.scrollTo('pieces');
  };

  BedBuilder.prototype.lockFrom = function (step) {
    var order = ['size', 'color', 'pieces'];
    for (var i = order.indexOf(step); i < order.length; i++) this.q('[data-bb-step="' + order[i] + '"]').classList.add('is-locked');
    if (order.indexOf(step) <= 2) { this.state.lines = {}; this.q('[data-bb-pieces]').innerHTML = ''; this.update(); }
  };

  /* A "line" is one row in step 4: a piece type with a list of choices, the chosen one, qty and on/off. */
  BedBuilder.prototype.buildLines = function () {
    var st = this.state, bed = st.size, color = st.color, counts = Core.defaultCounts(bed);
    var colorKey = color.name.toLowerCase();
    var styleSrc = st.style.name + ' ' + (st.style.detail || '') + ' ' + (st.style.sample || '');
    var mk = function (product, piece) {
      var c = product.color || color.name;
      return { variantId: piece.variantId, price: piece.price, available: piece.available, label: piece.label, color: c, image: piece.image || product.image, src: product.productTitle || '', title: (product.name || product.productTitle || '') + (c && c !== 'As Shown' ? ', ' + c : '') };
    };
    var own = function (kind, filter) {
      return color.pieces.filter(function (p) { return p.piece === kind && p.available && (!filter || filter(p)); })
        .map(function (p) { return { variantId: p.variantId, price: p.price, available: true, label: p.label, color: color.name, image: p.image || color.image, src: styleSrc, title: st.style.name + ' - ' + color.name }; });
    };
    var fromAddons = function (kind, filter) {
      var out = [];
      (this.model.addons[kind] || []).forEach(function (prod) {
        prod.pieces.forEach(function (p) { if (p.available && (!filter || filter(p))) out.push(mk(prod, p)); });
      });
      // Coordinating colors first
      out.sort(function (a, b) { return colorDistance(a.color, color.name) - colorDistance(b.color, color.name); });
      return out;
    }.bind(this);

    var duvet = Core.pieceFor(color.pieces, 'duvet', bed);
    var shamOwn = own('sham');
    var pcOwn = own('pillowcase');
    var sheetOwn = own('sheetset', function (p) { return p.size === bed; });
    var skirtOwn = own('bedskirt', function (p) { return p.size === bed; });
    var preferKing = bed === 'king';
    var pickSub = function (list) {
      var want = preferKing ? 'King' : 'Standard';
      for (var i = 0; i < list.length; i++) if (list[i].label.indexOf(want) > -1) return i;
      return 0;
    };

    var lines = {};
    lines.duvet = { kind: 'duvet', choices: [mk({ color: color.name, image: color.image, productTitle: styleSrc }, duvet)], idx: 0, qty: 1, on: true };
    var shams = shamOwn.length ? shamOwn : fromAddons('sham');
    if (shams.length) lines.sham = { kind: 'sham', choices: shams, idx: pickSub(shams), qty: counts.sham, on: !!shamOwn.length, own: !!shamOwn.length };
    var pcs = pcOwn.length ? pcOwn : fromAddons('pillowcase');
    if (pcs.length) lines.pillowcase = { kind: 'pillowcase', choices: pcs, idx: pickSub(pcs), qty: counts.pillowcase, on: !!pcOwn.length, own: !!pcOwn.length };
    var sheets = sheetOwn.length ? sheetOwn : fromAddons('sheetset', function (p) { return p.size === bed; });
    if (sheets.length) lines.sheetset = { kind: 'sheetset', choices: sheets, idx: 0, qty: 1, on: false, own: !!sheetOwn.length };
    var skirts = skirtOwn.length ? skirtOwn : fromAddons('bedskirt', function (p) { return p.size === bed; });
    if (skirts.length) lines.bedskirt = { kind: 'bedskirt', choices: skirts, idx: 0, qty: 1, on: false, own: !!skirtOwn.length };
    ['pillow', 'throw'].forEach(function (kind) {
      var list = [];
      this.extras.filter(function (x) { return x.kind === kind; }).forEach(function (x) {
        x.variants.forEach(function (v) {
          var colorName = (x.colorName || (x.title.match(/-\s*([^-]+)$/) || [])[1] || 'As Shown').trim();
          var short = x.name && x.item ? x.name + ' ' + x.item + (colorName !== 'As Shown' ? ', ' + colorName : '') : x.title;
          list.push({ variantId: v.id, price: v.price, available: true, label: v.label === 'Default Title' ? '' : v.label, color: colorName, image: v.image || x.image, src: x.title, title: short });
        });
      });
      list.sort(function (a, b) { return colorDistance(a.color, color.name) - colorDistance(b.color, color.name); });
      if (list.length) lines[kind] = { kind: kind, choices: list, idx: 0, qty: 1, on: false, extra: true };
    }, this);
    this.state.lines = lines;
  };

  BedBuilder.prototype.renderPieces = function () {
    var self = this;
    var order = ['duvet', 'sham', 'pillowcase', 'sheetset', 'bedskirt', 'pillow', 'throw'];
    var html = order.filter(function (k) { return self.state.lines[k]; }).map(function (k) {
      var line = self.state.lines[k];
      var opts = line.choices.map(function (c, i) {
        var text = (line.own || k === 'duvet') ? c.label : (c.title + (c.label ? ' · ' + c.label : ''));
        return '<option value="' + i + '"' + (i === line.idx ? ' selected' : '') + '>' + esc(text) + ' (' + self.money(c.price) + ')</option>';
      }).join('');
      var heading = k === 'pillow' ? 'Finishing touches' : '';
      return (heading ? '<p class="BedBuilder__Group">' + heading + '</p>' : '') +
        '<div class="BedBuilder__Piece' + (line.on ? ' is-on' : '') + '" data-bb-line="' + k + '">' +
          '<label class="BedBuilder__Toggle"><input type="checkbox" data-bb-toggle="' + k + '"' + (line.on ? ' checked' : '') + '><span>' + PIECE_NAMES[k] + '</span></label>' +
          (line.choices.length > 1 || !line.own ? '<select class="BedBuilder__Select" data-bb-choice="' + k + '" aria-label="' + PIECE_NAMES[k] + ' option">' + opts + '</select>' : '<span class="BedBuilder__Fixed">' + esc(line.choices[0].label) + '</span>') +
          '<div class="BedBuilder__Qty" role="group" aria-label="Quantity">' +
            '<button type="button" data-bb-qty="' + k + '" data-d="-1" aria-label="Fewer">&minus;</button>' +
            '<span data-bb-qtyval="' + k + '">' + line.qty + '</span>' +
            '<button type="button" data-bb-qty="' + k + '" data-d="1" aria-label="More">+</button>' +
          '</div>' +
          '<span class="BedBuilder__LinePrice" data-bb-price="' + k + '"></span>' +
        '</div>';
    }).join('');
    this.q('[data-bb-pieces]').innerHTML = html;
  };

  BedBuilder.prototype.update = function () {
    var self = this, total = 0, count = 0, lines = this.state.lines;
    ['duvet', 'sham', 'pillowcase', 'sheetset', 'bedskirt', 'pillow', 'throw'].forEach(function (k) {
      var line = lines[k];
      var row = self.q('[data-bb-line="' + k + '"]');
      if (!line) { self.paint(k, null); return; }
      var c = line.choices[line.idx];
      if (row) {
        row.classList.toggle('is-on', line.on);
        self.q('[data-bb-qtyval="' + k + '"]').textContent = line.qty;
        self.q('[data-bb-price="' + k + '"]').textContent = line.on ? self.money(c.price * line.qty) : '';
      }
      if (line.on) { total += c.price * line.qty; count += line.qty; }
      self.paint(k, line.on ? { color: c.color, src: c.src || c.title } : null, line.qty);
    });
    this.renderBoard();
    this.q('[data-bb-total]').textContent = this.money(total);
    this.q('[data-bb-count]').textContent = count + (count === 1 ? ' piece' : ' pieces');
    this.q('[data-bb-add]').disabled = !count;
    this.caption();
  };

  // Real product photos of every piece in the bed, in the order they go on
  BedBuilder.prototype.renderBoard = function () {
    var self = this, lines = this.state.lines, st = this.state;
    var on = ['duvet', 'sham', 'pillowcase', 'sheetset', 'bedskirt', 'pillow', 'throw'].filter(function (k) { return lines[k] && lines[k].on; });
    var board = this.q('[data-bb-board]');
    if (!board) return;
    board.hidden = !on.length;
    this.q('[data-bb-board-list]').innerHTML = on.map(function (k) {
      var line = lines[k], c = line.choices[line.idx];
      var name = line.own || k === 'duvet' ? st.style.name + ', ' + c.color : c.title;
      return '<li class="BedBuilder__BoardItem">' +
        '<span class="BedBuilder__BoardImg" style="background-image:url(' + esc(cropUrl(c.image, 240)) + ')">' + (line.qty > 1 ? '<em>&times;' + line.qty + '</em>' : '') + '</span>' +
        '<span class="BedBuilder__BoardPiece">' + PIECE_NAMES[k] + '</span>' +
        '<span class="BedBuilder__BoardName">' + esc(name) + (c.label ? ' · ' + esc(c.label) : '') + '</span>' +
      '</li>';
    }).join('');
  };

  // Deep link: ?style=ambrosia&size=queen&color=white opens the builder already set up
  BedBuilder.prototype.applyParams = function () {
    var p = new URLSearchParams(window.location.search), self = this;
    var want = (p.get('style') || '').toLowerCase(), size = (p.get('size') || '').toLowerCase(), color = (p.get('color') || '').toLowerCase();
    if (!want) return;
    var si = -1;
    this.model.styles.forEach(function (s, i) { if (si < 0 && (s.name + ' ' + s.key).toLowerCase().indexOf(want) > -1) si = i; });
    if (si < 0) return;
    this.selectStyle(si);
    if (Core.BED_SIZES.indexOf(size) > -1 && this.q('[data-bb-size="' + size + '"]:not([disabled])')) this.selectSize(size);
    if (this.state.size && color) {
      var ci = -1;
      this.state.style.colors.forEach(function (c, i) { if (ci < 0 && c.name.toLowerCase().indexOf(color) > -1 && self.q('[data-bb-color="' + i + '"]:not([disabled])')) ci = i; });
      if (ci > -1) this.selectColor(ci);
    }
  };

  BedBuilder.prototype.caption = function () {
    var st = this.state, t;
    if (!st.style) t = 'Pick a style to start dressing your bed.';
    else if (!st.size) t = st.style.name + '. Now choose your bed size.';
    else if (!st.color) t = st.style.name + ', ' + SIZE_NAMES[st.size] + '. Pick a color.';
    else t = st.style.name + ' in ' + st.color.name + ', ' + SIZE_NAMES[st.size] + ' bed.';
    if (this.q('[data-bb-caption]')) this.q('[data-bb-caption]').textContent = t;
  };

  BedBuilder.prototype.scrollTo = function (step) {
    if (window.matchMedia('(min-width: 1000px)').matches) return;
    var li = this.q('[data-bb-step="' + step + '"]');
    var top = li.getBoundingClientRect().top + window.pageYOffset - ((this.q('.BedBuilder__Stage') ? this.q('.BedBuilder__Stage').offsetHeight : 0) + 20);
    window.scrollTo({ top: top });
  };

  BedBuilder.prototype.addToCart = function () {
    var self = this, items = [];
    Object.keys(this.state.lines).forEach(function (k) {
      var line = self.state.lines[k];
      if (line.on && line.qty > 0) items.push({ id: line.choices[line.idx].variantId, quantity: line.qty, properties: { _source: 'Customize My Bed' } });
    });
    if (!items.length) return;
    var btn = this.q('[data-bb-add]'), err = this.q('[data-bb-error]');
    btn.disabled = true; btn.textContent = 'Adding your bed…'; err.hidden = true;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      })
      .catch(function (e) {
        err.textContent = e.message + '. Please adjust your selection and try again.';
        err.hidden = false; btn.disabled = false; btn.textContent = 'Add my bed to cart';
      });
  };

  BedBuilder.prototype.bind = function () {
    var self = this;
    this.el.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || t.disabled) return;
      if (t.hasAttribute('data-bb-style')) self.selectStyle(+t.getAttribute('data-bb-style'));
      else if (t.hasAttribute('data-bb-size')) self.selectSize(t.getAttribute('data-bb-size'));
      else if (t.hasAttribute('data-bb-color')) self.selectColor(+t.getAttribute('data-bb-color'));
      else if (t.hasAttribute('data-bb-qty')) {
        var line = self.state.lines[t.getAttribute('data-bb-qty')];
        line.qty = Math.max(1, Math.min(10, line.qty + +t.getAttribute('data-d')));
        line.on = true;
        self.q('[data-bb-toggle="' + line.kind + '"]').checked = true;
        self.update();
      } else if (t.hasAttribute('data-bb-add')) self.addToCart();
    });
    this.el.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-bb-toggle')) { self.state.lines[t.getAttribute('data-bb-toggle')].on = t.checked; self.update(); }
      if (t.hasAttribute('data-bb-choice')) {
        var line = self.state.lines[t.getAttribute('data-bb-choice')];
        line.idx = +t.value; line.on = true;
        self.q('[data-bb-toggle="' + line.kind + '"]').checked = true;
        self.update();
      }
    });
  };

  function init() {
    [].forEach.call(document.querySelectorAll('.BedBuilder'), function (el) {
      if (!el.__bb) el.__bb = new BedBuilder(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
